/* eslint-disable camelcase */
import { useTrack } from '@hotjar/webapp/hooks/useTrack';
import { useState } from 'react';
import type { Event, UiPosition } from './events';

interface ModalTrackingData {
  account_id: number | null;
  organization_id: number | null;
  site_id?: number | null;
}

export interface OrganizationModalEventsConfig {
  opened: Event;
  confirm: Event;
  uiPosition: UiPosition;
  organizationId: number;
  accountId: number;
  siteId?: number;
}

export interface OrganizationModalEvents {
  trackOpened(state: boolean): void;
  trackClicked(): void;
}

export function useModalEvents({
  confirm,
  opened,
  organizationId,
  accountId,
  uiPosition,
  siteId,
}: OrganizationModalEventsConfig): OrganizationModalEvents {
  const { click, viewElement } = useTrack();
  // track previous open state to avoid multiple viewElement events
  const [isAlreadyOpen, setIsAlreadyOpen] = useState(false);

  const trackingData: ModalTrackingData = {
    account_id: accountId,
    organization_id: organizationId,
  };

  if (siteId) {
    trackingData.site_id = siteId;
  }

  return {
    trackOpened: (isOpen) => {
      if (isOpen && !isAlreadyOpen) {
        viewElement(opened, uiPosition, trackingData);
      }
      setIsAlreadyOpen(isOpen);
    },
    trackClicked: () => {
      click(confirm, uiPosition, trackingData);
    },
  };
}
